import { Icons } from '@shared/components/content/icons';
import { LucideProps } from 'lucide-react';
import React from 'react';

export type LifecycleStageLabel =
  | 'Farming'
  | 'Processing'
  | 'Packaging'
  | 'Transport';

export interface LifecycleStage {
  stage: LifecycleStageLabel;
  description: string;
  icon: React.ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
  >;
  color: string;
  lightColor: string;
  // Pre-computed equivalent of color-mix(in srgb, lightColor 40%, white)
  // Used as a fallback for renderers that don't support color-mix (e.g. html2canvas)
  bgColor: string;
  bgClassName: string;
  borderClassName: string;
}

export const LIFECYCLE_STAGES: LifecycleStage[] = [
  {
    stage: 'Farming',
    description:
      'Emissions from creating the raw ingredients before processing begins',
    icon: Icons.tractor,
    color: 'var(--farming-default)',
    lightColor: 'var(--farming-light)',
    bgColor: '#f3f8f5',
    bgClassName: '',
    borderClassName: 'border-farming',
  },
  {
    stage: 'Processing',
    description:
      'Includes ingredient processing and any product processing you perform',
    icon: Icons.factory,
    color: 'var(--processing-default)',
    lightColor: 'var(--processing-light)',
    bgColor: '#e9f1f9',
    bgClassName: '',
    borderClassName: 'border-processing',
  },
  {
    stage: 'Packaging',
    description:
      'Includes ingredient packaging and any product packaging you add',
    icon: Icons.package,
    color: 'var(--packaging-default)',
    lightColor: 'var(--packaging-light)',
    bgColor: '#fff7e7',
    bgClassName: '',
    borderClassName: 'border-packaging',
  },
  {
    stage: 'Transport',
    description:
      'Includes ingredient transportation and transport of your product to stores',
    icon: Icons.truck,
    color: 'var(--transport-default)',
    lightColor: 'var(--transport-light)',
    bgColor: '#ffede3',
    bgClassName: '',
    borderClassName: 'border-transport',
  },
];
